<template>
  <div class="w-full">
    <date-picker
      id="date-range-custom"
      ref="datePicker"
      v-model="dateRange"
      type="date"
      range
      format="DD-MM-YYYY"
      value-type="DD-MM-YYYY"
      :placeholder="$t('FILTER.SELECT_DATE_RANGE')"
      class="w-full"
      input-class="mb-0"
      :confirm="true"
      :clearable="false"
      :shortcuts="monthShortcuts"
    >
      <template #header>
        <div>
          <div class="quick-filter-title text-sm text-slate-900 mb-2">
            {{ $t('FILTER.QUICK_FILTERS') }}
          </div>
          <div
            class="quick-filter-item flex flex-row rtl:flex-grow-reverse gap-1"
          >
            <span
              v-for="filter in quickFilters"
              :key="filter.type"
              class="text-xs text-gray-600 px-4 py-1 border border-gray-200 bg-gray-50 rounded-md cursor-pointer hover:border-[#1F845A] hover:text-[#1F845A] hover:bg-[#F0FDF4]"
              @click="selectQuickRange(filter)"
            >
              {{ filter.label }}
            </span>
          </div>
        </div>
      </template>
      <template #footer="{ emit }">
        <div class="flex flex-row justify-end gap-2 custom-datepicker-footer">
          <woot-button
            class="button clear"
            color-scheme="secondary"
            size="small"
            @click="cancelDateSelection(emit)"
          >
            {{ $t('FILTER.CANCEL_BUTTON_LABEL') }}
          </woot-button>
          <woot-button
            color-scheme=""
            class="!bg-green-500"
            size="small"
            @click="confirmDateSelection"
          >
            {{ $t('FILTER.APPLY_BUTTON_LABEL') }}
          </woot-button>
        </div>
      </template>
      <template #icon-calendar>
        <svg
          width="17"
          height="20"
          viewBox="0 0 17 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.80775 19.1152C1.30258 19.1152 0.875 18.9403 0.525 18.5903C0.175 18.2402 0 17.8127 0 17.3075V3.923C0 3.41783 0.175 2.99025 0.525 2.64025C0.875 2.29025 1.30258 2.11525 1.80775 2.11525H3.19225V0H4.73075V2.11525H12.3077V0H13.8077V2.11525H15.1923C15.6974 2.11525 16.125 2.29025 16.475 2.64025C16.825 2.99025 17 3.41783 17 3.923V17.3075C17 17.8127 16.825 18.2402 16.475 18.5903C16.125 18.9403 15.6974 19.1152 15.1923 19.1152H1.80775ZM1.80775 17.6152H15.1923C15.2692 17.6152 15.3398 17.5832 15.4038 17.519C15.4679 17.455 15.5 17.3845 15.5 17.3075V7.923H1.5V17.3075C1.5 17.3845 1.53208 17.455 1.59625 17.519C1.66025 17.5832 1.73075 17.6152 1.80775 17.6152ZM1.5 6.423H15.5V3.923C15.5 3.846 15.4679 3.7755 15.4038 3.7115C15.3398 3.64733 15.2692 3.61525 15.1923 3.61525H1.80775C1.73075 3.61525 1.66025 3.64733 1.59625 3.7115C1.53208 3.7755 1.5 3.846 1.5 3.923V6.423ZM8.5 11.6922C8.25517 11.6922 8.0465 11.606 7.874 11.4335C7.70167 11.2612 7.6155 11.0525 7.6155 10.8075C7.6155 10.5627 7.70167 10.354 7.874 10.1815C8.0465 10.0092 8.25517 9.923 8.5 9.923C8.74483 9.923 8.9535 10.0092 9.126 10.1815C9.29833 10.354 9.3845 10.5627 9.3845 10.8075C9.3845 11.0525 9.29833 11.2612 9.126 11.4335C8.9535 11.606 8.74483 11.6922 8.5 11.6922ZM4.5 11.6922C4.25517 11.6922 4.0465 11.606 3.874 11.4335C3.70167 11.2612 3.6155 11.0525 3.6155 10.8075C3.6155 10.5627 3.70167 10.354 3.874 10.1815C4.0465 10.0092 4.25517 9.923 4.5 9.923C4.74483 9.923 4.9535 10.0092 5.126 10.1815C5.29833 10.354 5.3845 10.5627 5.3845 10.8075C5.3845 11.0525 5.29833 11.2612 5.126 11.4335C4.9535 11.606 4.74483 11.6922 4.5 11.6922ZM12.5 11.6922C12.2552 11.6922 12.0465 11.606 11.874 11.4335C11.7017 11.2612 11.6155 11.0525 11.6155 10.8075C11.6155 10.5627 11.7017 10.354 11.874 10.1815C12.0465 10.0092 12.2552 9.923 12.5 9.923C12.7448 9.923 12.9535 10.0092 13.126 10.1815C13.2983 10.354 13.3845 10.5627 13.3845 10.8075C13.3845 11.0525 13.2983 11.2612 13.126 11.4335C12.9535 11.606 12.7448 11.6922 12.5 11.6922ZM8.5 15.6152C8.25517 15.6152 8.0465 15.529 7.874 15.3565C7.70167 15.1842 7.6155 14.9756 7.6155 14.7308C7.6155 14.4858 7.70167 14.2771 7.874 14.1047C8.0465 13.9322 8.25517 13.846 8.5 13.846C8.74483 13.846 8.9535 13.9322 9.126 14.1047C9.29833 14.2771 9.3845 14.4858 9.3845 14.7308C9.3845 14.9756 9.29833 15.1842 9.126 15.3565C8.9535 15.529 8.74483 15.6152 8.5 15.6152ZM4.5 15.6152C4.25517 15.6152 4.0465 15.529 3.874 15.3565C3.70167 15.1842 3.6155 14.9756 3.6155 14.7308C3.6155 14.4858 3.70167 14.2771 3.874 14.1047C4.0465 13.9322 4.25517 13.846 4.5 13.846C4.74483 13.846 4.9535 13.9322 5.126 14.1047C5.29833 14.2771 5.3845 14.4858 5.3845 14.7308C5.3845 14.9756 5.29833 15.1842 5.126 15.3565C4.9535 15.529 4.74483 15.6152 4.5 15.6152ZM12.5 15.6152C12.2552 15.6152 12.0465 15.529 11.874 15.3565C11.7017 15.1842 11.6155 14.9756 11.6155 14.7308C11.6155 14.4858 11.7017 14.2771 11.874 14.1047C12.0465 13.9322 12.2552 13.846 12.5 13.846C12.7448 13.846 12.9535 13.9322 13.126 14.1047C13.2983 14.2771 13.3845 14.4858 13.3845 14.7308C13.3845 14.9756 13.2983 15.1842 13.126 15.3565C12.9535 15.529 12.7448 15.6152 12.5 15.6152Z"
            fill="#6B7280"
            style="
              fill: #6b7280;
              fill: color(display-p3 0.4196 0.4471 0.502);
              fill-opacity: 1;
            "
          />
        </svg>
      </template>
    </date-picker>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';

export default {
  components: {
    DatePicker,
  },
  props: {
    value: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      quickFilters: [
        { label: this.$t('FILTER.TODAY'), offsetDays: 0 },
        { label: this.$t('FILTER.LAST_7_DAYS'), offsetDays: -6 },
        { label: this.$t('FILTER.LAST_30_DAYS'), offsetDays: -29 },
        { label: this.$t('FILTER.THIS_MONTH'), month: true },
        { label: this.$t('FILTER.THIS_YEAR'), year: true },
      ],
      monthShortcuts: this.$t('FILTER.MONTH_NAMES').map((name, index) => ({
        text: name,
        onClick() {
          const year = new Date().getFullYear();
          return [new Date(year, index, 1), new Date(year, index + 1, 0)];
        },
      })),
    };
  },
  computed: {
    dateRange: {
      get() {
        if (this.value && this.value.from && this.value.to) {
          return [this.value.from, this.value.to];
        }
        return null;
      },
      set(value) {
        if (Array.isArray(value) && value.length === 2) {
          this.$emit('input', { from: value[0], to: value[1] });
        }
      },
    },
  },
  mounted() {
    const locale = this.$i18n.locale;
    import(`vue2-datepicker/locale/${locale}`).catch(() => {
      import('vue2-datepicker/locale/en');
    });
  },
  methods: {
    formatDate(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
    selectQuickRange({ offsetDays, month, year: isYear }) {
      const today = new Date();
      let start;
      let end = today;

      if (isYear) {
        start = new Date(today.getFullYear(), 0, 1);
        end = new Date(today.getFullYear(), 11, 31);
      } else if (month) {
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      } else {
        start = new Date();
        start.setDate(today.getDate() + offsetDays);
      }

      this.dateRange = [this.formatDate(start), this.formatDate(end)];
      if (this.$refs.datePicker) {
        this.$refs.datePicker.closePopup();
      }
    },
    confirmDateSelection() {
      if (this.$refs.datePicker) {
        this.$refs.datePicker.handleConfirmDate();
      }
    },
    cancelDateSelection(emit) {
      if (this.$refs.datePicker && this.dateRange) {
        const dateRange = this.dateRange.map(date => {
          const [day, month, year] = date.split('-').map(Number);
          return new Date(year, month - 1, day);
        });
        emit(dateRange);
      }
      this.$refs.datePicker.closePopup();
    },
  },
};
</script>

<style lang="scss">
.mx-datepicker-main {
  &.mx-datepicker-popup {
    @apply bg-transparent border-none flex flex-row;
    box-shadow: none;
  }

  .mx-datepicker-sidebar {
    @apply bg-white rounded-[4px] border border-slate-100 flex flex-col p-1 gap-2 justify-center;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    button {
      @apply hover:bg-[#F0FDF4] hover:text-[#1F845A] font-[400] text-xs px-2 py-1;
    }
  }

  .mx-datepicker-content {
    @apply bg-white rounded-[4px] border border-slate-100 ml-1;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);

    .cell {
      @apply hover:bg-[#F0FDF4] hover:text-green-500;

      &.today {
        @apply text-[#1F845A] font-semibold;
      }
    }
  }

  .mx-datepicker-header {
    @apply px-3 py-3.5;
  }
}

.mx-calendar-content {
  .cell.active {
    @apply bg-green-500 rounded-md;
  }

  // Start Date
  .cell.active:has(~ .cell.in-range),
  .cell.active:has(~ .cell.hover-in-range),
  .cell.active:has(~ .cell.active) {
    @apply rounded-l-md rounded-r-none;
  }

  // End Date
  .cell.in-range + .cell.active,
  .cell.hover-in-range + .cell.active,
  .cell.active + .cell.active {
    @apply rounded-r-md rounded-l-none;
  }

  .cell.in-range,
  .cell.hover-in-range {
    @apply bg-green-50;
  }
}
.mx-calendar-header,
.mx-calendar-header-label {
  button.mx-btn {
    @apply hover:text-green-500;
  }
}

[dir='rtl'] {
  ~ .mx-datepicker-main {
    &.mx-datepicker-popup {
      @apply flex-row-reverse;
    }

    .mx-datepicker-content {
      @apply ml-0 mr-1;
    }

    .mx-datepicker-sidebar {
      button {
        @apply text-right;
      }
    }

    .quick-filter-title {
      @apply text-right;
    }

    .quick-filter-item {
      @apply flex-row-reverse;
      span {
        direction: rtl;
      }
    }
  }

  .mx-icon-calendar {
    left: 12px !important;
  }
}
</style>
